<template>
  <div>
    <header class="lmy-header lmy-header-w" style="box-shadow: 0px 10px 20px rgb(0 0 0 / 5%)">
      <i class="iconfont icon-back" onclick="window.history.go(-1)"></i>
      填写订单
    </header>
    <div class="lmy-purchase">
      <div class="lmy-pur-content">
        <div class="rush-text">
          {{PackageBookInfo.ProductName}}
          <span style="color: #2391ff;font-size: .26rem;font-weight: normal;position: absolute;right: 0;bottom: -0.35rem;" @click="$router.push('/packageDetails?ProductId='+PackageBookInfo.ProductId)">查看</span>
        </div>
        <div class="content-body">{{PackageBookInfo.SkuName}}</div>
        <div class="price">￥{{PackageBookInfo.HandleItem.Price}}<span style="color:#333;font-size: 0.28rem;font-weight: initial;"> /套</span></div>
      </div>
      <div class="lmy-pur-content">
        <div class="content-head" v-if="PackageBookInfo&&PackageBookInfo.SkuPieces.length>0">产品包含</div>
        <div class="content-body">
          <div v-for="S,index in PackageBookInfo.SkuPieces" :key="index" v-if="S">
            {{S}}
          </div>
        </div>
        <div v-if="Detail.Type==1" class="content-head">取消规则</div>
        <div v-if="Detail.Type==1" class="content-body">
          <div style="color:#eb3941;" v-if="!PackageBookInfo.HandleItem.AllowCancel">此订单即订即保，订单一经确认，不可取消更改</div>
          <div style="color:#eb3941;" v-if="PackageBookInfo.HandleItem.AllowCancel&&PackageBookInfo.HandleItem.CancelDate">最后可取消时间为：{{CancelDate}}</div>
        </div>
        <div class="date" v-if="Detail.Type==1">您选择的出发日期为：<span style='font-weight:bold'>{{PackageBookInfo.HandleItem.Date}}</span></div>
        <div class="date" v-else>有效期至：<span style='font-weight:bold'>{{Detail.BookingEnd|dateToYMDline}}</span></div>
      </div>

      <div class="select-count">
        <div class="select-count-item-a">
          <span>选择份数</span>
          <span style="margin-left: 2rem;color:#ff6600">限购5份</span>
          <div class="compute">
            <span class="sub" @click="minus">-</span>
            <span class="count">{{stock}}</span>
            <span class="plus" @click="plus">+</span>
          </div>
        </div>
      </div>

      <!-- <div class="room-people-toast">港澳及海外产品必须填写英文或拼音</div> -->
      <div class="lmy-reservation-order" style="padding:0;padding-top:.2rem">
         <div class="people-info">
                <div class="info-title" style="text-align: center;font-weight: bold;">
                    填写订单信息
                </div>
                <div class="room-people-toast"> ' * ' 符号为必填信息</div>
                <div v-for="G,index in Groups" v-if="Detail.Type==1">
                    <div class="info-title" style="margin-top:0.3rem;color:#c8a973">旅客 {{Groups.length>1?index+1:''}}</div>
                    <div class="info-item">
                        <div class="item-label"><span style="color:red">* </span>姓名</div>
                        <div class="item-body">
                            <input type="text" placeholder="姓名需与证件保持一致" v-model="G.CnName">
                        </div>
                    </div>
                    <div class="info-item" v-if="PackageBookInfo.IsIdcard">
                        <div class="item-label"><span style="color:red">* </span>身份证</div>
                        <div class="item-body">
                            <input type="text" placeholder="填写身份证号码" v-model="G.CardNumber">
                        </div>
                    </div>
                </div>
                <div class="info-item" style="margin-top: 0.3rem;">
                    <div class="item-label"><span style="color:red">* </span>手机号</div>
                    <div class="item-body">
                        <input type="text" placeholder="方便我们更好为您服务" v-model="Phone">
                    </div>
                </div>
                <!-- <div class="info-item" v-if="Detail.Type==1" @click="isInvoiceBox=true">
                  <div class="item-label">发票</div>
                  <div class="item-body">{{isInvoice?'增值税普通发票':'不需要开票'}}</div>
                    <i class="iconfont icon-more"></i>
                </div> -->
                <div class="info-item">
                  <div class="item-label">备注</div>
                  <div class="item-body">
                    <input type="text" placeholder="请输入" v-model="SpecialRequest">
                  </div>
                </div>
            </div>
      </div>
      <div v-for="N,index in Detail.Notice" :key="index" v-if="index=='购买须知'">
        <div class="content-head">{{index}}</div>
        <div class="content-body" v-html="N"></div>
      </div>
      <div style="margin-top: 0.6rem;" v-for="N,index in Detail.Notice" :key="index" v-if="index=='发票说明'">
        <div class="content-head">{{index}}</div>
        <div class="content-body" v-html="N"></div>
      </div>
      <!-- <div class="content-head">关于发票</div>
      <div class="content-body">发票由「捷银国旅」开具，支持普通发票，开票内容：旅游服务*旅游服务费。默认支持电子普票，纸质普票邮寄方式为快递到付！</div> -->
      
      <div class="order-btn" >
          <div >应付：<label class="price">¥ <span class="num">{{(stock*PackageBookInfo.HandleItem.Price).toFixed(1)}}</span></label></div>
          <div class="submit-btn" @click="checkBookAble">去支付</div>
      </div>

      <div class="book-comfirming" v-if="isSubmit">
        <div class='f-modal' >
          <div class='f-modal-head'>提示</div>
          <div class='f-modal-body'>
            <p>正在下单，请稍候...</p>
          </div>
        </div>
      </div>
    </div>
    <transition name="slide">
      <invoice v-show="isInvoiceBox==true" @offInvoice="offInvoice" @modifyInvoice="modifyInvoice" :payPricy="(stock*PackageBookInfo.HandleItem.Price)" :Currency="PackageBookInfo.Currency"></invoice>
    </transition>  
  </div>
</template>

<script>
import Invoice from '../book/reserve/invoice'
export default {
  name: "free-book",
  components: {
    Invoice
  },
  data: function() {
    return {
      Detail: JSON.parse(this.dao.get("packageDetails")) || "",
      PackageBookInfo: JSON.parse(this.dao.get("packageBookInfo")) || "",
      stock: JSON.parse(this.dao.get("packageBookInfo")).MinCount || 1,
      isSubmit: false,
      Groups: [
        {
          CnName: "",
          CardNumber: "",
          NeedIDCard: JSON.parse(this.dao.get("packageBookInfo")).IsIdcard
        }
      ],
      Phone:JSON.parse(this.dao.get("userInfo")).Phone||'',
      SpecialRequest: "",
      isInvoiceBox: false,
      isInvoice: false,
      invoiceData: '',
    };
  },
  methods: {
    // 是否开发票
    modifyInvoice(item, value) {
      this.isInvoiceBox = false;
      this.isInvoice = item;
      this.invoiceData = value;
    },
    // 开票页返回时触发事件
    offInvoice() {
      this.isInvoiceBox = false;
      this.isInvoice = false;
    },
    // 开票
    // setInvoice(OrderNO) {
    //   var that = this;
    //   that.invoiceData.OrderOrBillNo = OrderNO;
    //   var param = that.invoiceData;
    //   this.postRequest({
    //     url: that.Api.InvoiceSave,
    //     params: param
    //   }).then(res => {
    //     if (res && res.IsSuccess) {
    //       console.log("已成功开票");
    //     } else {
    //       console.log("未成功开票");
    //     }
    //   });
    // },
    //票数减1
    minus() {
      if (this.stock == this.PackageBookInfo.MinCount) {
        this.error({ title: "提示", content: "已至最少购买数量" });
        return;
      }
      this.stock -= 1;
      if(this.Detail.Type==1){
        this.Groups.pop();
      }
      
    },
    //票数加1
    plus() {
      var guestItem = {
        CnName: "",
        CardNumber: "",
        NeedIDCard: JSON.parse(this.dao.get("packageBookInfo")).IsIdcard
      }
      if (this.Detail.Type == 1) {
        if (!this.PackageBookInfo.HandleItem.Status) {
          if (this.PackageBookInfo.HandleItem.IsAskRoom) {
            if (this.stock < this.PackageBookInfo.MaxCount && this.stock < 5) {
              this.stock += 1;
              this.Groups.push(guestItem);
            } else {
              this.error({ title: "提示", content: "已至最大购买数量" });
              return;
            }
          } else {
            if (
              this.stock < this.PackageBookInfo.MaxCount &&
              this.stock < this.PackageBookInfo.HandleItem.Stock &&
              this.stock < 5
            ) {
              this.stock += 1;
              this.Groups.push(guestItem);
            } else {
              this.error({ title: "提示", content: "已至最大购买数量" });
              return;
            }
          }
        }
      } else {
        if (
          this.stock < this.PackageBookInfo.MaxCount &&
          this.stock < this.PackageBookInfo.Stock &&
          this.stock < 5
        ) {
          this.stock += 1;
        } else {
          this.error({ title: "提示", content: "已至最大购买数量" });
          return;
        }
      }
    },
    isPhoneAvailable(phone) {
      var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!myreg.test(phone)) {
        return false;
      } else {
        return true;
      }
    },

    checkBookAble() {
      var that = this;
      var data = that.Groups;
      var SFreg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      var reg = new RegExp(
        "^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"
      );
      for (let item = 0; item < data.length; item++) {
        if (that.PackageBookInfo.IsIdcard&&that.Detail.Type==1) {
          if (
            !(data[item].CnName && data[item].CardNumber)
          ) {
            that.$alert("您有未填写的信息，请继续填写");
            return;
          } else if (!SFreg.test(data[item].CardNumber)) {
            that.$alert("您的身份证格式有误，请您核对");
            return;
          }
        } else if(that.Detail.Type==1&&!that.PackageBookInfo.IsIdcard){
          if (!(data[item].CnName)) {
            that.$alert("您的姓名未填写，请继续填写");
            return;
          }
        }

        if (!that.Phone) {
          that.$alert("您联系方式尚未填写");
          return;
        } else if (!that.isPhoneAvailable(that.Phone)) {
          that.$alert("您的手机格式有误，请您核对");
          return;
        }
      }
      if (that.Detail.Type == 1) {
        var dateTime
        if(that.PackageBookInfo.HandleItem.Date){
          dateTime = new Date(that.PackageBookInfo.HandleItem.Date)
          dateTime = dateTime.setDate(dateTime.getDate()+1)
          dateTime = new Date(dateTime)
          dateTime = that.dateToYMDline(dateTime)
        }
        that.isSubmit = true;
        var param = {
          token:
            that.PackageBookInfo.Token || that.PackageBookInfo.HandleItem.Token,
          Count: that.stock,
          CheckIn: that.PackageBookInfo.HandleItem.Date || that.getDate(0),
          CheckOut: dateTime||that.getDate(1)
        };
        that
          .postRequest({
            url: that.Api.getOnlinePackageCheck,
            params: param
          })
          .then(res => {
            that.isSubmit = false;
            if (res.IsSuccess) {
              that.PackageBookInfo.Count = that.stock;
              that.dao.set(
                "packageBookInfo",
                JSON.stringify(that.PackageBookInfo)
              );
              that.book();
            } else {
              that.error({ title: "提示", content: res.Msg || "不能预订" });
            }
          });
      } else {
        that.PackageBookInfo.Count = that.stock;
        that.dao.set("packageBookInfo", JSON.stringify(that.PackageBookInfo));
        that.book();
      }
    },
    book() {
      var that = this;
      var param = {
        Count: that.stock,
        Token:
          that.PackageBookInfo.Token || that.PackageBookInfo.HandleItem.Token,
        Guests: that.Groups,
        Phone:that.Phone,
        SpecialRequest: that.SpecialRequest,
        IsInvoice: false,
        Invoices:'',
        // IsInvoice: that.isInvoice,
        // Invoices: that.invoiceData,
      };
      that.isSubmit = true;
      that
        .postRequest({
          url: that.Api.getOnlinePackageCreate,
          params: JSON.stringify(param)
        })
        .then(res => {
          that.isSubmit = false;
          if (res && res.IsSuccess) {
            that.OrderNO = res.Result.QGOrderNO;
            that.dao.set("thisBookingOrderNO", that.OrderNO);
            that.$router.push({ path: '/wxPay',query:{OrderNO:that.OrderNO}});
          } else if (!res.IsSuccess) {
            this.error({ title: "提示", content: res.Msg });
          }
        });
    },
  },
  mounted() {}
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/free/book.vue